import React, { Component } from 'react';
import Header from './Header/Header';
import Modal, { DefaultModalParams } from './Modal/Modal';
import Credentials from './Credentials/Credentials';
import { Paper } from '@material-ui/core';
import MoveBooking from './MoveBooking/MoveBooking';
import Confirmation from './Confirmation/Confirmation';
import {connect} from "react-redux";
import Spinner from './subComponents/Spinner';
import TextPanel from './TextPanel/TextPanel';

export const AppStep = Object.freeze({
  Loading: 0,
  Credentials: 1,
  MoveBooking: 2,
  Confirmation: 3,
  Failure: 4
});

const mapStateToProps = (state) => {
  // console.log('state', state);
  return {
    MoveBooking: state.MoveBooking,
    appStep: state.step
  };
}

const mapDispatchToProps = (dispatch) => ({});

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      credentialsError: false,
      loading: true,
      modalOpen: false,
      modalParams: DefaultModalParams
    }
  }

  onCloseModal = () => {
    this.setState({
      modalOpen: false
    });
  }

  openModal = (params) => {
    this.setState({
      modalOpen: true,
      modalParams: params
    });
  }

  switcher = step => {
    switch (step) {
      case AppStep.Credentials:
        return <Credentials />;
      case AppStep.Loading:
        return <Spinner />;
      case AppStep.MoveBooking:
        return <MoveBooking />;
      case AppStep.Confirmation:
        return <Confirmation />;
      case AppStep.Failure:
        return <TextPanel text={'Something went wrong. Please try again.'} showBack={true} />;
      default:
        return <div>Something went wrong.</div>;
    }
  }

  render() {
    return (
      <div className="AppContainer">
        <Header
          header={'Move Booking'.toLocaleUpperCase()}
          subHeader={this.props.appStep === AppStep.Credentials ? 'Please Enter Credentials'.toLocaleUpperCase() : ''}
          hideOnMobile={true}
        />
        <Paper className={'Main'}>
          {this.switcher(this.props.appStep)}
        </Paper>
        <Modal
          isOpen={this.state.modalOpen}
          handleClose={this.onCloseModal}
          {...this.state.modalParams}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
